import settings from '@/settings'
import * as base64ToArrayBuffer from 'base64-arraybuffer'

/**
 * 録音した音声をBase64にして保存
 * @param arrayBuffer 音データ
 */
export function save (arrayBuffer: ArrayBuffer): boolean {
  console.log('save', arrayBuffer.byteLength > 0, arrayBuffer)
  if (arrayBuffer.byteLength > 0) {
    const base64String = base64ToArrayBuffer.encode(arrayBuffer)
    window.localStorage.setItem(settings.localStorage.recorded, base64String)
    return true
  } else {
    return false
  }
}

/**
 * 保存した音声を取得
 */
export function load (): ArrayBuffer | null {
  const loadedString = window.localStorage.getItem(settings.localStorage.recorded)
  return (loadedString !== null) ? base64ToArrayBuffer.decode(loadedString) : null
}

/**
 * 保存した音声を削除
 */
export function clear () {
  window.localStorage.removeItem(settings.localStorage.recorded)
}
